import PublicProfile from "@/components/PublicProfile";
import { useRouteParams } from "@/hooks/useRouteParams";

// /u/@id — the public contribution record for one account: identity, tier, counts, points, and
// their reviews. Entirely SEPARATE from `pages/profile/`, which is the signed-in user's own
// account-settings page; merging the two would put a settings form behind a public URL.
export default function Page() {
  const params = useRouteParams();
  const id = params.id ?? "";

  return (
    <div
      dir="rtl"
      style={{
        background: "var(--ys-bg)",
        minHeight: "100vh",
        padding: "32px 16px",
        fontFamily: "var(--ys-font)",
      }}
    >
      <div style={{ maxWidth: 680, margin: "0 auto" }}>
        <PublicProfile userId={id} />
      </div>
    </div>
  );
}
